import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { RangeFilterComponent } from '../range-filter/range-filter.component';
interface Region {
  name: string;
  code: string;
}

@Component({
  selector: 'app-plant-filter',
  templateUrl: './plant-filter.component.html',
  styleUrls: ['./plant-filter.component.scss'],
})
export class PlantFilterComponent implements OnInit {
  @ViewChildren(RangeFilterComponent) rangeFilterComponents: QueryList<RangeFilterComponent>;
  filters: any = {
    region: null,
    ranges: {},
  };
  rangeFilters = [
    { label: 'Space Available (Units)', key: 'space_available', min: 0, max: 100, step: 1 },
    { label: 'Fixed Cost ($MM)', key: 'fixed_cost', min: 0, max: 50, step: 1 },
    { label: 'Variable Cost ($MM)', key: 'variable_cost', min: 0, max: 200, step: 5 },
    { label: 'Operational Cost ($MM)', key: 'operational_cost', min: 0, max: 100, step: 2 },
  ];
  regions: Region[] | undefined;

  selectedRegion: Region | undefined;

  ngOnInit() {
    this.regions = [
      { name: 'United States', code: 'US' },
      { name: 'Canada', code: 'CA' },
      { name: 'Mexico', code: 'MX' },
      { name: 'Turkey', code: 'TK' },
    ];
  }

  clearFilters(type) {
    this.selectedRegion = null;
    this.filters.ranges = {};
    this.rangeFilters.forEach((filter, index) => {
      this.filters.ranges[filter.key] = { min: filter.min, max: filter.max };
    });

    // resetting each range filter
    this.rangeFilterComponents.forEach((component) => component.reset());

    this.applyFilters();
  }

  onRangeFilterChange(label: string, values: { min: number; max: number }) {
    this.filters.ranges[label] = values;
  }

  applyFilters() {
    this.filters.region = this.selectedRegion?.name || '';
    console.log('Applied filters:', this.filters);
  }
}
